import type { FaireProductEntity } from "../../entity_types/product";

export const p_hvyz93jdgc: FaireProductEntity = {
  token: "p_hvyz93jdgc",
  type: "product",
  name: "Trippy Mushrooms Women's Novelty Crew Socks",
  brandToken: "b_6nu7ayhqaw",
  brandName: "Fabdaz",
  imageUrl:
    "https://cdn.faire.com/fastly/85981b1902a1c88fe213f20c65ad3b0c6a708ba96e7ca1e06bde266592427457.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2fb6e0daec1a635d92d5b133bc7f8163c1a412449a7ff413212e682e2c21034.jpeg",
    "https://cdn.faire.com/fastly/6ff840e6a36d6c6f5191f99d1cabcfae335a9a98f67efb4bd0d406d23c5f68f9.jpeg",
    "https://cdn.faire.com/fastly/f7e149b8d212a4cdfa9522ac10e133309a393e1b8298f888dc5d28ce3af5ef07.jpeg",
    "https://cdn.faire.com/fastly/4f14ea29293f61c2b41a6e0a2b8b2e1de361894ef3b7ea5ae447c6f2777d55be.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Trippy Mushrooms Women's Crew Socks.\nStylish and comfortable!\nFits ladies' shoe size 5 to 10.\n80% Cotton, 15% Nylon, 5% Spandex.\nEasy Care - Machine Wash.\nItem # SK0083\nPacked on card peg hook ready, UPC coded.\nDesigned in Chattanooga, TN by our in-house artist Jennifer.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:28.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
